import { Component, input } from '@angular/core';

import { ToastRefAfterClosed } from '../toast-ref';
import { ToastComponent } from '../toast.component';
import { Toast } from '../toast.service';

@Component({
  selector: 'liv-toast-container',
  standalone: true,
  imports: [ToastComponent],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss'
})
export class ToastContainerComponent {
  readonly toasts = input<Toast[]>([]);
  readonly onToastClosed =
    input<(instanceId: string, dismissedByAction: boolean) => void>();

  onToastClosedHandler({
    instanceId,
    dismissedByAction
  }: ToastRefAfterClosed): void {
    this.onToastClosed()(instanceId, dismissedByAction);
  }
}
